import { WebglObject, GraphicPanel, FixedDimension } from "../../../../web-graphics";

/*
 _______________________________________
|     |_____top_content___________|     |
|_____|___top_central_content_____|_____|
|  |  |                           |  |  |
|  |left central content          |right central content
|  |  |                           |  |  |
|  |  |      central content      |  |  |
|  |  |                           |  |  |
|  |  |                           |  |right content
|left content                     |  |  |
|__|__|___________________________|__|__|
|     |__bottom_central_content___|     |
|_____|_______bottom_content______|_____|

central content has 3 layers:
1) above central content
2) central content (middle)
3) under central content

*/

/*
contentBorders: {
  topHeight: CalculatedDimension,       // height of top content
  bottomHeight: CalculatedDimension,    // height of bottom content
  leftWidth: CalculatedDimension,       // width of left content
  rightWidth: CalculatedDimension,      // width of right content
  topCentralHeight: CalculatedDimension,       // height of top central content
  bottomCentralHeight: CalculatedDimension,    // height of bottom central content
  leftCentralWidth: CalculatedDimension,       // width of left central content
  rightCentralWidth: CalculatedDimension,      // width of right central content
}
*/

export class DockBox extends WebglObject {
  constructor(settings) {
    super(settings);
    // set borders if undefined
    if (this.settings.contentBorders.topCentralHeight === undefined) {
      this.settings.contentBorders.topCentralHeight = new FixedDimension(0);
    }
    if (this.settings.contentBorders.topHeight === undefined) {
      this.settings.contentBorders.topHeight = this.settings.contentBorders.topCentralHeight;
    }
    if (this.settings.contentBorders.bottomCentralHeight === undefined) {
      this.settings.contentBorders.bottomCentralHeight = new FixedDimension(0);
    }
    if (this.settings.contentBorders.bottomHeight === undefined) {
      this.settings.contentBorders.bottomHeight = this.settings.contentBorders.bottomCentralHeight;
    }
    if (this.settings.contentBorders.leftCentralWidth === undefined) {
      this.settings.contentBorders.leftCentralWidth = new FixedDimension(0);
    }
    if (this.settings.contentBorders.leftWidth === undefined) {
      this.settings.contentBorders.leftWidth = this.settings.contentBorders.leftCentralWidth;
    }
    if (this.settings.contentBorders.rightCentralWidth === undefined) {
      this.settings.contentBorders.rightCentralWidth = new FixedDimension(0);
    }
    if (this.settings.contentBorders.rightWidth === undefined) {
      this.settings.contentBorders.rightWidth = this.settings.contentBorders.rightCentralWidth;
    }
    DockBox.calculateContentBordersInPixels(this.settings);

    // create child panels
    this.content = {
      central: new GraphicPanel(
        DockBox.createPanelSettings(
          this.settings.contentBorders.leftWidthInPixels,
          this.settings.contentBorders.bottomHeightInPixels,
          this.settings.clientSize.width - this.settings.contentBorders.leftWidthInPixels - this.settings.contentBorders.rightWidthInPixels,
          this.settings.clientSize.height - this.settings.contentBorders.topHeightInPixels - this.settings.contentBorders.bottomHeightInPixels,
          this.settings,
          this
        )
      ),
      aboveCentral: new GraphicPanel(
        DockBox.createPanelSettings(
          this.settings.contentBorders.leftWidthInPixels,
          this.settings.contentBorders.bottomHeightInPixels,
          this.settings.clientSize.width - this.settings.contentBorders.leftWidthInPixels - this.settings.contentBorders.rightWidthInPixels,
          this.settings.clientSize.height - this.settings.contentBorders.topHeightInPixels - this.settings.contentBorders.bottomHeightInPixels,
          this.settings,
          this
        )
      ),
      underCentral: new GraphicPanel(
        DockBox.createPanelSettings(
          this.settings.contentBorders.leftWidthInPixels,
          this.settings.contentBorders.bottomHeightInPixels,
          this.settings.clientSize.width - this.settings.contentBorders.leftWidthInPixels - this.settings.contentBorders.rightWidthInPixels,
          this.settings.clientSize.height - this.settings.contentBorders.topHeightInPixels - this.settings.contentBorders.bottomHeightInPixels,
          this.settings,
          this
        )
      ),
      bottom:
        this.settings.contentBorders.bottomHeightInPixels == 0
          ? undefined
          : new GraphicPanel(
            DockBox.createPanelSettings(
              0,
              0,
              this.settings.clientSize.width,
              this.settings.contentBorders.bottomHeight,
              this.settings,
              this
            )
          ),
      bottomCentral: undefined,
      top:
        this.settings.contentBorders.topHeightInPixels == 0
          ? undefined
          : new GraphicPanel(
            DockBox.createPanelSettings(
              0,
              this.settings.clientSize.height - this.settings.contentBorders.topHeightInPixels,
              this.settings.clientSize.width,
              this.settings.contentBorders.topHeightInPixels,
              this.settings,
              this
            )
          ),
      topCentral: undefined,
      left:
        this.settings.contentBorders.leftWidthInPixels == 0
          ? undefined
          : new GraphicPanel(
            DockBox.createPanelSettings(
              0,
              0,
              this.settings.contentBorders.leftWidthInPixels,
              this.settings.clientSize.height,
              this.settings,
              this
            )
          ),
      leftCentral: undefined,
      right:
        this.settings.contentBorders.rightWidthInPixels == 0
          ? undefined
          : new GraphicPanel(
            DockBox.createPanelSettings(
              this.settings.contentBorders.widthInPixels - this.settings.contentBorders.rightWidthInPixels,
              0,
              this.settings.contentBorders.rightWidthInPixels,
              this.settings.clientSize.height,
              this.settings,
              this
            )
          ),
      rightCentral: undefined
    };
    if (this.settings.contentBorders.bottomHeightInPixels > 0) {
      let bottomCentralHeight = this.settings.contentBorders.bottomHeightInPixels;
      if (this.settings.contentBorders.bottomCentralHeightInPixels > 0) {
        bottomCentralHeight = this.settings.contentBorders.bottomCentralHeightInPixels;
      }
      this.content.bottomCentral = new GraphicPanel(
        DockBox.createPanelSettings(
          this.settings.contentBorders.leftWidthInPixels,
          this.settings.contentBorders.bottomHeightInPixels - bottomCentralHeight,
          this.settings.clientSize.width - this.settings.contentBorders.leftWidthInPixels - this.settings.contentBorders.rightWidthInPixels,
          bottomCentralHeight,
          this.settings,
          this
        )
      );
    }
    if (this.settings.contentBorders.topHeightInPixels > 0) {
      let topCentralHeight = this.settings.contentBorders.topHeightInPixels;
      if (this.settings.contentBorders.topCentralHeightInPixels > 0) {
        topCentralHeight = this.settings.contentBorders.topCentralHeightInPixels;
      }
      this.content.topCentral = new GraphicPanel(
        DockBox.createPanelSettings(
          this.settings.contentBorders.leftWidthInPixels,
          this.settings.clientSize.height - this.settings.contentBorders.topHeightInPixels,
          this.settings.clientSize.width - this.settings.contentBorders.leftWidthInPixels - this.settings.contentBorders.rightWidthInPixels,
          topCentralHeight,
          this.settings,
          this
        )
      );
    }
    if (this.settings.contentBorders.leftWidthInPixels > 0) {
      let leftCentralWidth = this.settings.contentBorders.leftWidthInPixels;
      if (this.settings.contentBorders.leftCentralWidthInPixels > 0) {
        leftCentralWidth = this.settings.contentBorders.leftCentralWidthInPixels;
      }
      this.content.leftCentral = new GraphicPanel(
        DockBox.createPanelSettings(
          this.settings.contentBorders.leftWidthInPixels - leftCentralWidth,
          this.settings.contentBorders.bottomHeightInPixels,
          leftCentralWidth,
          this.settings.clientSize.height - this.settings.contentBorders.bottomHeightInPixels - this.settings.contentBorders.topHeightInPixels,
          this.settings,
          this
        )
      );
    }
    if (this.settings.contentBorders.rightWidthInPixels > 0) {
      let rightCentralWidth = this.settings.contentBorders.rightWidthInPixels;
      if (this.settings.contentBorders.rightCentralWidthInPixels > 0) {
        rightCentralWidth = this.settings.contentBorders.rightCentralWidthInPixels;
      }
      this.content.rightCentral = new GraphicPanel(
        DockBox.createPanelSettings(
          this.settings.clientSize.width - this.settings.contentBorders.rightWidthInPixels,
          this.settings.contentBorders.bottomHeightInPixels,
          rightCentralWidth,
          this.settings.clientSize.height - this.settings.contentBorders.bottomHeightInPixels - this.settings.contentBorders.topHeightInPixels,
          this.settings,
          this
        )
      );
    }
    
    this.settings.debug.boxFillColor = [1, 0.5, 1, 1];
    this.settings.debug.boxStrokeColor = [1, 0, 0.5, 1];
    this.contentNames = [
      "central",
      "aboveCentral",
      "underCentral",
      "bottom",
      "bottomCentral",
      "top",
      "topCentral",
      "left",
      "leftCentral",
      "right",
      "rightCentral"
    ];
  }

  static calculateContentBordersInPixels(settings) {
    settings.contentBorders.topHeightInPixels = settings.contentBorders.topHeight.calcValue(settings.clientSize.height);
    settings.contentBorders.bottomHeightInPixels = settings.contentBorders.bottomHeight.calcValue(settings.clientSize.height);
    settings.contentBorders.leftWidthInPixels = settings.contentBorders.leftWidth.calcValue(settings.clientSize.width);
    settings.contentBorders.rightWidthInPixels = settings.contentBorders.rightWidth.calcValue(settings.clientSize.width);
    settings.contentBorders.topCentralHeightInPixels = settings.contentBorders.topCentralHeight.calcValue(settings.clientSize.height);
    settings.contentBorders.bottomCentralHeightInPixels = settings.contentBorders.bottomCentralHeight.calcValue(settings.clientSize.height);
    settings.contentBorders.leftCentralWidthInPixels = settings.contentBorders.leftCentralWidth.calcValue(settings.clientSize.width);
    settings.contentBorders.rightCentralWidthInPixels = settings.contentBorders.rightCentralWidth.calcValue(settings.clientSize.width);
  }

  static createPanelSettings(x, y, width, height, settings, parent) {
    return {
      location: {
        x: new FixedDimension(x),
        y: new FixedDimension(y)
      },
      size: {
        width: new FixedDimension(width),
        height: new FixedDimension(height)
      },
      parent: {
        ref: parent,
        isCustom: false,
        location: {
          x: settings.absoluteLocation.x,
          y: settings.absoluteLocation.y
        },
        size: {
          width: settings.clientSize.width,
          height: settings.clientSize.height
        },
        padding: {
          left: settings.paddingInPixels.left,
          right: settings.paddingInPixels.right,
          top: settings.paddingInPixels.top,
          bottom: settings.paddingInPixels.bottom
        }
      }
    };
  }

  addItem(item, place) {
    if (this.contentNames.contains(place)) {
      this.content[place]?.addItem(item);
    }
  }

  calculateCentralPanelBorders() {
    return {
      x: this.settings.contentBorders.leftWidthInPixels,
      y: this.settings.contentBorders.bottomHeightInPixels,
      width: this.settings.clientSize.width - this.settings.contentBorders.leftWidthInPixels - this.settings.contentBorders.rightWidthInPixels,
      height: this.settings.clientSize.height - this.settings.contentBorders.topHeightInPixels - this.settings.contentBorders.bottomHeightInPixels
    };
  }

  updateItemBorders(itemName, x, y, width, height) {
    if (this.content[itemName] === undefined) {
      return;
    }
    this.content[itemName].setParentSize(this.settings.sizeInPixels.width, this.settings.sizeInPixels.height);
    this.content[itemName].setBorders(
      {
        x: new FixedDimension(x),
        y: new FixedDimension(y)
      },
      {
        width: new FixedDimension(width),
        height: new FixedDimension(height)
      }
    );
    this.content[itemName].createBorders();
  }

  updateItemsBorders() {
    const centralPanelBorders = this.calculateCentralPanelBorders();
    this.updateItemBorders("central", centralPanelBorders.x, centralPanelBorders.y, centralPanelBorders.width, centralPanelBorders.height);
    this.updateItemBorders(
      "aboveCentral",
      centralPanelBorders.x,
      centralPanelBorders.y,
      centralPanelBorders.width,
      centralPanelBorders.height
    );
    this.updateItemBorders(
      "underCentral",
      centralPanelBorders.x,
      centralPanelBorders.y,
      centralPanelBorders.width,
      centralPanelBorders.height
    );
    if (this.settings.contentBorders.bottomHeightInPixels > 0) {
      this.updateItemBorders("bottom", 0, 0, this.settings.clientSize.width, this.settings.contentBorders.bottomHeight);
    }
    if (this.settings.contentBorders.topHeightInPixels > 0) {
      this.updateItemBorders(
        "top",
        0,
        this.settings.clientSize.height - this.settings.contentBorders.topHeightInPixels,
        this.settings.clientSize.width,
        this.settings.contentBorders.topHeightInPixels
      );
    }
    if (this.settings.contentBorders.leftWidthInPixels > 0) {
      this.updateItemBorders("left", 0, 0, this.settings.contentBorders.leftWidthInPixels, this.settings.clientSize.height);
    }
    if (this.settings.contentBorders.rightWidthInPixels > 0) {
      this.updateItemBorders(
        "right",
        this.settings.contentBorders.widthInPixels - this.settings.contentBorders.rightWidthInPixels,
        0,
        this.settings.contentBorders.rightWidthInPixels,
        this.settings.clientSize.height
      );
    }
    if (this.settings.contentBorders.bottomHeightInPixels > 0) {
      let bottomCentralHeight = this.settings.contentBorders.bottomHeightInPixels;
      if (this.settings.contentBorders.bottomCentralHeightInPixels > 0) {
        bottomCentralHeight = this.settings.contentBorders.bottomCentralHeightInPixels;
      }
      this.updateItemBorders(
        "bottomCentral",
        this.settings.contentBorders.leftWidthInPixels,
        this.settings.contentBorders.bottomHeightInPixels - bottomCentralHeight,
        this.settings.clientSize.width - this.settings.contentBorders.leftWidthInPixels - this.settings.contentBorders.rightWidthInPixels,
        bottomCentralHeight
      );
    }
    if (this.settings.contentBorders.topHeightInPixels > 0) {
      let topCentralHeight = this.settings.contentBorders.topHeightInPixels;
      if (this.settings.contentBorders.topCentralHeightInPixels > 0) {
        topCentralHeight = this.settings.contentBorders.topCentralHeightInPixels;
      }
      this.updateItemBorders(
        "topCentral",
        this.settings.contentBorders.leftWidthInPixels,
        this.settings.clientSize.height - this.settings.contentBorders.topHeightInPixels,
        this.settings.clientSize.width - this.settings.contentBorders.leftWidthInPixels - this.settings.contentBorders.rightWidthInPixels,
        topCentralHeight
      );
    }
    if (this.settings.contentBorders.leftWidthInPixels > 0) {
      let leftCentralWidth = this.settings.contentBorders.leftWidthInPixels;
      if (this.settings.contentBorders.leftCentralWidthInPixels > 0) {
        leftCentralWidth = this.settings.contentBorders.leftCentralWidthInPixels;
      }
      this.updateItemBorders(
        "leftCentral",
        this.settings.contentBorders.leftWidthInPixels - leftCentralWidth,
        this.settings.contentBorders.bottomHeightInPixels,
        leftCentralWidth,
        this.settings.clientSize.height - this.settings.contentBorders.bottomHeightInPixels - this.settings.contentBorders.topHeightInPixels
      );
    }
    if (this.settings.contentBorders.rightWidthInPixels > 0) {
      let rightCentralWidth = this.settings.contentBorders.rightWidthInPixels;
      if (this.settings.contentBorders.rightCentralWidthInPixels > 0) {
        rightCentralWidth = this.settings.contentBorders.rightCentralWidthInPixels;
      }
      this.updateItemBorders(
        "rightCentral",
        this.settings.clientSize.width - this.settings.contentBorders.rightWidthInPixels,
        this.settings.contentBorders.bottomHeightInPixels,
        rightCentralWidth,
        this.settings.clientSize.height - this.settings.contentBorders.bottomHeightInPixels - this.settings.contentBorders.topHeightInPixels
      );
    }
  }

  createBorders() {
    super.createBorders();
    DockBox.calculateContentBordersInPixels(this.settings);
    this.updateItemsBorders();
  }

  setItemsContainerDebugMode(items, debugSettings) {
    for (let i = 0; i < items.length; i++) {
      items[i].setDebugMode(debugSettings);
    }
  }

  setDebugMode(debugSettings) {
    super.setDebugMode(debugSettings);
    for (let i = 0; i < this.contentNames.length; i++) {
      this.content[this.contentNames[i]]?.setDebugMode({ ...debugSettings });
    }
    if (this.content.underCentral !== undefined) {
      if (this.content.central !== undefined) {
        this.content.central.settings.debug.isTransparentBackground = true;
        if (this.content.aboveCentral !== undefined) {
          this.content.aboveCentral.settings.debug.isTransparentBackground = true;
        }
      }
    } else if (this.content.central !== undefined && this.content.aboveCentral !== undefined) {
      this.content.aboveCentral.settings.debug.isTransparentBackground = true;
    }
  }

  drawItemsContainer(items, gl, program) {
    for (let i = 0; i < items.length; i++) {
      items[i].draw(gl, program);
    }
  }

  draw(gl, program) {
    super.draw(gl, program);
    this.content.underCentral?.draw(gl, program);
    this.content.central?.draw(gl, program);
    this.content.bottom?.draw(gl, program);
    this.content.top?.draw(gl, program);
    this.content.left?.draw(gl, program);
    this.content.right?.draw(gl, program);
    this.content.bottomCentral?.draw(gl, program);
    this.content.topCentral?.draw(gl, program);
    this.content.leftCentral?.draw(gl, program);
    this.content.rightCentral?.draw(gl, program);
    this.content.aboveCentral?.draw(gl, program);
  }
}
